
// CWI CODE J
const videoSliders = document.querySelectorAll(".video_image_slider .video_image_block.swiper");

if (videoSliders.length) {
  videoSliders.forEach((banner_slider) => {
    const parentSlider = banner_slider.closest(".video_image_slider");
    const paginationEl = parentSlider.querySelector(".swiper-pagination");

    const Banner_slider = new Swiper(banner_slider, {
      slidesPerView: 1,
      autoHeight: true,
      loop: true,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
    });
  });
}


window.addEventListener("load", () => {
  const comp = document.querySelector("shopify-buy-it-now-button");
  const child = comp.querySelector(".shopify-payment-button__button");
  child.textContent = 'Buy Now';
});

